<template>
  <div :class="{ scale: params.max == 5 }">
    <div class="linear-scale">
      <div
        class="linear-scale__option"
        v-for="(option, indice) in options"
        :key="option"
        @click="continueStep(indice + 1)"
        :style="{ background: option }"
      >
        {{ indice + 1 }}
      </div>
    </div>
    <div class="linear-scale__text-feedback-container">
      <p class="linear-scale__text-feedback">
        Pouco<br />
        satisfeito
      </p>
      <p class="linear-scale__text-feedback linear-scale__text-feedback--right">
        Extremamente<br />
        satisfeito
      </p>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "VLinearScale",
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState("Quiz", ["currentQuestion"]),
    options() {
      const { max } = this.params;

      const options = {
        "5": [
          "rgb(239, 78, 78)",
          "rgb(255, 111, 56)",
          "rgb(247, 211, 107)",
          "rgb(176, 226, 121)",
          "rgb(116, 232, 116)"
        ],
        "10": [
          "#ef4949",
          "#ff6f38",
          "#fdba75",
          "#f5ce5f",
          "#e4e067",
          "#dcec57",
          "#8bef8b",
          "#79f179",
          "#80e080",
          "#59d859"
        ]
      };

      return options[max];
    }
  },
  methods: {
    ...mapMutations("Quiz", ["updateResponse"]),
    continueStep(num) {
      this.updateResponse({
        question: this.currentQuestion.uuid,
        response: num
      });

      this.$emit("continue");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.scale {
  max-width: 500px;
  margin: 0 auto;
  transform: scale(1.2);
}

.linear-scale {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  @media #{$small-and-down} {
    justify-content: center;
  }

  @media #{$large-and-up} {
    justify-content: center;
  }
  margin: 0 -6px;

  &__option {
    width: 9vw;
    height: 9vw;
    border-radius: 2px;
    box-shadow: 0px 8px 8px rgba(224, 224, 224, 0.2);
    margin: 1px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 4vw;
    font-weight: 600;
    cursor: pointer;

    @media #{$small-and-down} {
      width: 40px;
      height: 40px;
      margin: 8px;
    }
    @media #{$large-and-up} {
      width: 5vw;
      height: 5vw;
      margin: 0vw;
      font-size: 3vw;
    }
  }

  &__text-feedback-container {
    display: flex;
    justify-content: space-between;
    
    @media #{$large-and-up} {
      margin: 0 25% 0 25%;
    }
  }
  &__text-feedback {
    font-size: 2.5vw;
    font-weight: 600;
    color: #3c3d3d;
    &--right {
      text-align: right;
    }
    @media #{$large-and-up} {
      font-size: 1vw;
    }
  }
}
</style>
